import React from 'react';

import Login from '../pages/features/auth/Login';
import MFAVerification from '../pages/features/auth/MFAVerification';
import ProductionLogin from '../pages/features/auth/ProductionLogin';
import CPOLanding from '../pages/features/landings/CPOLanding';
import FleetLanding from '../pages/features/landings/FleetLanding';
import GovernmentLanding from '../pages/features/landings/GovernmentLanding';
import OEMLanding from '../pages/features/landings/OEMLanding';
import RealEstateLanding from '../pages/features/landings/RealEstateLanding';
import ResidentialLanding from '../pages/features/landings/ResidentialLanding';
import RetailLanding from '../pages/features/landings/RetailLanding';

export const publicRoutes = [
  { path: '/login', element: <Login /> },
  { path: '/mfa', element: <MFAVerification /> },
  { path: '/production-login', element: <ProductionLogin /> },
  { path: '/cpo', element: <CPOLanding /> },
  { path: '/government', element: <GovernmentLanding /> },
  { path: '/fleet', element: <FleetLanding /> },
  { path: '/oem', element: <OEMLanding /> },
  { path: '/realestate', element: <RealEstateLanding /> },
  { path: '/retail', element: <RetailLanding /> },
  { path: '/residential', element: <ResidentialLanding /> },
];
